<template>
  <div id="modalEditPrice" class="modal fade" aria-hidden="true">
    <div
      role="document"
      class="modal-dialog modal-dialog-vertical-center modal-sm"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("order.编辑采购价格") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <div class="form-group row align-items-center mg-b-5">
            <label
              for="iptPrice"
              class="
                col-md-4 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("order.SKU供应商") }}</label
            >
            <div class="col-md-8 col-sm-12">
              <p class="mg-b-0">{{ item._name }}</p>
            </div>
          </div>
          <div class="form-group row align-items-center mg-b-5">
            <label
              for="iptPrice"
              class="
                col-md-4 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("order.当前采购金额") }}</label
            >
            <div class="col-md-4 col-sm-12">
              <p class="mg-b-0">{{ item.price }}</p>
            </div>
          </div>
          <div class="form-group row mg-b-0">
            <label
              for="iptPrice"
              class="
                col-md-4 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
              >{{ $t("order.修改采购金额") }}</label
            >
            <div class="col-md-4 col-sm-12">
              <input
                type="text"
                name="price"
                id="iptPrice"
                class="form-control form-control-sm"
                v-PRICE
                v-model.number="price"
                @keyup.enter="save"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="save"
          >
            {{ $t("other.提交") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
            aria-label="Close"
          >
            {{ $t("order.取消") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      price: "",
    };
  },
  mounted() {
    $("#modalEditPrice").on("hidden.bs.modal", (e) => {
      this.price = "";
    });
  },
  methods: {
    // 限制输入的字符必须是数组和小数点
    testPrice(e) {
      if (e.type == "keyup") {
        let reg = e.target.value.match(/\d+\.?\d{0,2}/);
        let txt = "";
        if (reg != null) {
          txt = reg[0];
        }
        e.target.value = txt;
        this.price = e.target.value;
      } else if (e.type == "change") {
        let evt = new Event("keypress");
        e.target.dispatchEvent(evt);
        let txt = e.target.value;
        if (/\.$/.test(txt)) {
          e.target.value = txt.substr(0, txt.length - 1);
        }
        this.price = e.target.value;
      }
    },
    // 提交编辑后的结果
    save() {
      if (this.price == 0) {
        ShowTip(this.$t("distributor.价格不能为零"), "danger");
        return false;
      }
      let reg = /^\d+(\.\d{1,2})?$/;
      if (!reg.test(this.price)) {
        ShowTip(this.$t("distributor.请输入正确的数字"), "danger");
        return false;
      }
      this.$parent.loading = true;
      $.api_call(
        "api.SupplierPurchaseOrder.modifySkuPrice",
        {
          code: this.item._code,
          supplierStockId: this.item.id,
          price: this.price,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("mall.修改成功"), "success");
            $("#modalEditPrice").modal("hide");
            setTimeout(() => {
              this.$parent.getRMOrder(true);
            }, 1000);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>